import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import objectPrototypeAccessorsForced from '../internals/object-prototype-accessors-forced.js';
import toObject$1 from '../internals/to-object.js';
import toPropertyKey$1 from '../internals/to-property-key.js';
import objectGetPrototypeOf from '../internals/object-get-prototype-of.js';
import '../internals/object-get-own-property-descriptor.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var FORCED = objectPrototypeAccessorsForced;
var toObject = toObject$1;
var toPropertyKey = toPropertyKey$1;
var getPrototypeOf = objectGetPrototypeOf;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f; // `Object.prototype.__lookupSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__

if (DESCRIPTORS) {
  $({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var key = toPropertyKey(P);
      var desc;

      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
      } while (O = getPrototypeOf(O));
    }
  });
}
